export const telegram = {
  main: "https://t.me/animixlib",
  chat: "https://t.me/animixchatix",
  apps: "https://t.me/animixapps",
};
